import ReferenceDownloads from './reference-downloads';

export default class ReferenceDownloadsDesktop extends ReferenceDownloads {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/reference-downloads/reference-downloads.desktop.js